import React, { useEffect, useState } from "react";
import './style.css';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import InputLabel from "@material-ui/core/InputLabel";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPeriods } from "./action";

const RenderDatePicker = (props) => {
  const dispatch = useDispatch();
  const { selectedPeriods } = useSelector((store) => store.notesReducer);
  
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null); 

  const handleInputChange = (e) => {
    e.preventDefault(); // Prevent any change in the input field
  };

  const handleChange = ([newStartDate, newEndDate]) => {
    console.log("Date range selected:", { startDate: newStartDate, endDate: newEndDate });
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    
    // Generate array of periods between start and end date
    if (newStartDate && newEndDate) {
      const periods = generatePeriodsBetweenDates(newStartDate, newEndDate);
      console.log("Generated periods:", periods);
      dispatch(setSelectedPeriods(periods));
      
      // Call parent callback if provided
      if (props.onPeriodsChange) {
        props.onPeriodsChange(periods);
      }
    }
  };

  // Generate periods between two dates
  const generatePeriodsBetweenDates = (startDate, endDate) => {
    const periods = [];
    const current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    while (current <= end) {
      const month = ("0" + (current.getMonth() + 1)).slice(-2);
      const year = current.getFullYear();
      periods.push(`${month}-${year}`);
      current.setMonth(current.getMonth() + 1);
    }

    return periods;
  };

  return (
    <div style={{ marginTop: "9px" }}>
      <InputLabel
        id="demo-simple-select-autowidth-label"
        className="text_label-notes"
        style={{
          fontFamily: "GT-Walsheim-medium",
          fontSize: "12px",
          color: "black",
          top: "10px",
        }}
      >
        Select Period *
      </InputLabel>

      <DatePicker
        selected={startDate}
        onChange={handleChange}
        selectsRange
        startDate={startDate}
        endDate={endDate}
        dateFormat="MM-yyyy"
        showMonthYearPicker
        maxDate={new Date()}
        onKeyDown={handleInputChange}
        onKeyPress={handleInputChange}
        placeholderText="Select Period Range *"
      />

    </div>
  );
};

export default RenderDatePicker;
